import React from 'react'
import { ShowBookingDetails } from '../components/ShowBookingDetails'

export function Admin() {
    return (
        <div>
            {/* <h1>I'm Admin</h1> */}
            <ShowBookingDetails />
        </div>
    )
}




